<template v-if="exibicao === ''">
    <div class="card-produto">
        <div class="card-produto-header">
            <img class="card-produto-img" :src="produto.imagem" v-if="produto.imagem != null">
            <img class="card-produto-img" src="http://via.placeholder.com/250x200" v-if="produto.imagem == null">

            <div class="box-desconto" :style="produto.style" v-if="produto.comprejunto">
                <div class="text-center">
                    <b><span>{{produto.text}}</span></b>
                </div>
            </div>
        </div>
        <div class="card-produto-title" style="text-align: center;padding-top:5px; ">
            <span class="produto--nome">{{produto.nome}}</span>
        </div>
        <div class="card-produto-body">
            <div class="produto--detalhes sg-cor-secundaria" style="vertical-align: top; margin-top: 0px; min-height: 100px" v-if="!produto.comprejunto">
                <p><b>Ref.: </b> {{produto.referencia}}</p>
                <!--<p><b>Quantidade: </b>{{produto.quantidade}}</p>
                <p v-if="produto.tamanho_sangria != null && produto.tamanho_sangria != '' && produto.tamanho_sangria != 'x'"><b>Tam. Arte:</b> {{produto.tamanho_sangria}} | {{produto.cor}}</p>
                <p v-if="produto.cobertura != null && produto.cobertura != ''"><b>Cobertura:</b> {{produto.cobertura}}</p>
                <p v-if="produto.papel != null && produto.papel != ''"><b>Material: </b> {{produto.papel}}</p>-->
                <p v-if="produto.prazo_producao > 1 && produto.prazo_producao_periodo == 'd'"><b>Produção: </b> {{produto.prazo_producao}} dias</p>
                <p v-if="produto.prazo_producao <= 1 && produto.prazo_producao_periodo == 'd'"><b>Produção: </b> {{produto.prazo_producao}} dia</p>
                <p v-if="produto.prazo_producao > 1 && produto.prazo_producao_periodo == 'h'"><b>Produção: </b> {{produto.prazo_producao}} horas</p>
                <p v-if="produto.prazo_producao <= 1 && produto.prazo_producao_periodo == 'h'"><b>Produção: </b> {{produto.prazo_producao}} hora</p>
            </div>
            <div class="produto--detalhes sg-cor-secundaria" style="vertical-align: top; margin-top: 0px; min-height: 100px" v-if="produto.comprejunto">
                <p style="justify-content: center; display: flex;"><b>Produtos</b></p>
                <p v-for="p in produto.produtos" :key="p.id" style="justify-content: center; display: flex;">{{p.nome}}</p>
            </div>
            <div style="text-align: center" v-if="produto.preco_logado">
                <p class="produto--preco-por"><b>Logue-se para ver o preço</b></p>
            </div>
            <div style="text-align: center" v-else-if="produto.sob_consulta == 1">
                <p class="produto--preco-por"><b>Sob consulta</b></p>
            </div>
            <div style="text-align: center" v-else>
                <!--<span class="produto--preco-de" v-if="produto.preco_promocional">de: {{produto.preco_venda | currency(2)}} </span>
                <span class="produto--preco-de" v-if="produto.preco_promocional" style="font-size: 12px">&nbsp;por: </span>
                <p class="produto--preco-por" v-if="produto.preco_promocional"><b class="produto--preco-por"> {{produto.precoAttribute | currency(2)}}</b> </p>-->
                <span class="produto--preco-de" style="text-decoration: unset">à partir de:</span>
                <p class="produto--preco-por"><b class="produto--preco-por">{{produto.precoAttribute | currency(2)}}</b> </p>
            </div>
        </div>
        <div class="card-produto-footer-shadow">
        </div>
        <div class="card-produto-footer" v-if="produto.preco_logado">
            <a href="#login" data-toggle="modal" data-target="#modalLogin" class="btn sg-botao">
                <i class="fas fa-sign-in-alt"></i> Logar
            </a>
        </div>
        <div class="card-produto-footer" v-else>
            <a :href="produto.url" class="btn sg-botao">Comprar</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "card-produto",
        props: {
            produto: {
                default: null
            }
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/loja/vue-components/CardProduto.vue